import { render, staticRenderFns } from "./dredge_card.vue?vue&type=template&id=f08873de&scoped=true&"
import script from "./dredge_card.vue?vue&type=script&lang=js&"
export * from "./dredge_card.vue?vue&type=script&lang=js&"
import style0 from "./dredge_card.vue?vue&type=style&index=0&id=f08873de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08873de",
  null
  
)

export default component.exports